import styles from 'sections/encyclopedia-articles-reference/EncyclopediaArticlesReference.module.scss'
import { EncyclopediaArticlesReferenceProps } from 'sections/encyclopedia-articles-reference/types'
import { Grid } from '@boltenergy-be/design-system'
import ArticleCard from 'components/article/article-card/ArticleCard'
import { useTranslation } from 'next-i18next/pages'

const EncyclopediaArticlesReference = ({ title, articles }: EncyclopediaArticlesReferenceProps) => {
  // i18n
  const { t } = useTranslation()

  return (
    <Grid {...{ title }}>
      {articles?.map((article) => (
        <ArticleCard
          {...article}
          key={`${article.title}-${article.id}`}
          publishedAt={article.customPublishedAt ?? article.publishedAt}
          destination={article.destination}
          className={styles.article}
          customFooter={<small className={styles.link}>{t('readMore')}</small>}
        />
      ))}
    </Grid>
  )
}

export default EncyclopediaArticlesReference
